module.exports = __webpack_public_path__ + "static/media/monkey1@3x.d2e32ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/monkey1@3x.png
// module id = 764
// module chunks = 0